<div class="userResponse_Container" [ngStyle]="{'direction':isRTL?'rtl':'ltr'}">
    <div class="userResponse_matSpinnerContainer" *ngIf="presentSpinner">
        <mat-spinner [diameter]="70"   class="userResposne_spinner"></mat-spinner>
    </div>
    <div class="userResponse_postResponseContainer" [ngClass]="{'is-mobile-view': isMobileView}" *ngIf="responseSent && responsePresenationDetails">
        <div class="userResponse_messageToUserContainer">
            @if(responsePresenationDetails.isFirstTime){
                <span class="userResponse_MessageToUser" *ngIf="responsePresenationDetails.engagementType != userResponsePresentationDataTypeEnum_Instance.ConversationalQuestion">{{"userResponse.thankYouForResponding" | translate}}</span>
                <span class="userResponse_MessageToUser" *ngIf="responsePresenationDetails.engagementType == userResponsePresentationDataTypeEnum_Instance.ConversationalQuestion">{{"userResponse.thankYouForResponding_conversational" | translate}}</span>
            }
            @else{
                <span class="userResponse_MessageToUser" *ngIf="!responsePresenationDetails.isFirstTime">{{"userResponse.alreadyResponded" | translate}}</span>
            }
            <mat-divider class="userResponse_divider"></mat-divider>
        </div>
        <img class="userResponse_image" [ngClass]="{'is-mobile-view': isMobileView}" src={{getUserImagePath()}}>
        <span class="userResponse_postResponseHeader" *ngIf="this.responsePresenationDetails.header != ''">
            {{this.responsePresenationDetails.header}}
        </span>
        <span class="userResponse_postResponseSubHeader" *ngIf="this.responsePresenationDetails.subHeader != ''">
            {{this.responsePresenationDetails.subHeader}}
        </span>        
        <span class="userResponse_postResponseText" [ngClass]="{'is-mobile-view': isMobileView}" *ngIf="this.responsePresenationDetails.text != ''">
            {{this.responsePresenationDetails.text}}
        </span>
    </div>
    <div class="userResponse_postResponseContainer" [ngClass]="{'is-mobile-view': isMobileView}" *ngIf="responseSent && !responsePresenationDetails">
        <img class="userResponse_image" [ngClass]="{'is-mobile-view': isMobileView}" src={{getUserImagePath()}}>
        <span class="userResponse_postResponseError">{{"userResponse.error" | translate}}</span>
    </div>
    @if(responsePresenationDetails && responsePresenationDetails.engagementType != userResponsePresentationDataTypeEnum_Instance.ConversationalQuestion){
        <div class="userRepsponse_actionButtonsContainer">
            <button mat-raised-button color="primary" class="userResponse_actionButton" (click)="redirectToLogin()">{{"userResponse.redirectButton" | translate}}</button>
            <button mat-raised-button color="primary" class="userResponse_actionButton" (click)="sendTipToSelf()">{{"userResponse.sendTipToSelfButton" | translate}}</button>
        </div>    
    }
    @else if (responsePresenationDetails){
        <div class="userRepsponse_actionButtonsContainer">
            <button mat-raised-button color="primary" class="userResponse_actionButton" (click)="redirectToChat()">{{"userResponse.redirectToClairButton" | translate}}</button>
        </div>    
    }
</div>